import { render, staticRenderFns } from "./WEBDOWNLOADJOBS.vue?vue&type=template&id=56406996"
import script from "./WEBDOWNLOADJOBS.vue?vue&type=script&lang=js"
export * from "./WEBDOWNLOADJOBS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports